<template>
  <div class="section">
    <div class="container">
      <h1>About the Enforceability Index</h1>
      <div>
        The enforceability index, developed by the Aviation Working Group (AWG), assesses legal
        rules and practical experience within countries not yet party to the Cape Town Convention
        (CTC) based on whether, and the extent to which, they
        <u
          >facilitate customary creditor rights and remedies and align with financing and leasing
          principles in the global aviation market</u
        >.
      </div>
      <div>
        While the AWG secretariat has made all scoring decisions, it has benefitted from consensus
        input on legal facts and developments from multiple leading aviation finance firm in each
        country.
      </div>
      <div>
        The enforceability index builds on the analytical foundation in, and many years of
        experience developing, scoring, and revising, our CTC compliance index for CTC countries.
      </div>
      <div>
        The enforceability index aims to both inform financiers and investors and provide an
        incentive for legal authorities to take action, and exercise discretion, within their
        control to align with customary creditor rights and remedies and financing and leasing
        principles in the global aviation market.
      </div>
      <div>
        This enforceability index is meant as an <i>interim action</i> in the sense of AWG's
        promotion of CTC accession by all countries scored. We look forward, on their accession to
        CTC, to removing them from the enforceability index and adding them to CTC compliance index,
        as CTC in now widely acknowledged as international best practice and has been ratified or
        acceded to by 90 countries.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {},
  mounted() {},
};
</script>

